import styled from "styled-components";

export const StyledLightBulb = styled.svg.attrs({
  viewBox: "0 0 23 24",
  fill: "none",
})`
  width: 23px;
  height: 24px;
`;
